export const MODOS_EXIBICAO_SALDO = Object.freeze({
	AMBOS: "ambos",
	DIARIO: "diario",
	TOTAL: "total",
	OCULTO: "oculto",
})

const PERMITIDOS = new Set(Object.values(MODOS_EXIBICAO_SALDO))

export function normalizarModoExibicaoSaldo(valor) {
	const v = String(valor ?? "").trim().toLowerCase()
	return PERMITIDOS.has(v) ? v : MODOS_EXIBICAO_SALDO.DIARIO
}

export function componenteSaldoVisivel(modo) {
	return normalizarModoExibicaoSaldo(modo) !== MODOS_EXIBICAO_SALDO.OCULTO
}

export function permiteAlternarSaldo(modo) {
	return normalizarModoExibicaoSaldo(modo) === MODOS_EXIBICAO_SALDO.AMBOS
}

export function visaoInicialSaldo(modo) {
	const m = normalizarModoExibicaoSaldo(modo)
	return m === MODOS_EXIBICAO_SALDO.TOTAL ? "total" : "diario"
}

export function visaoEfetivaSaldo(modo, visaoUsuario) {
	const m = normalizarModoExibicaoSaldo(modo)
	if (m === MODOS_EXIBICAO_SALDO.OCULTO) return null
	if (m === MODOS_EXIBICAO_SALDO.DIARIO) return "diario"
	if (m === MODOS_EXIBICAO_SALDO.TOTAL) return "total"
	return visaoUsuario === "total" ? "total" : "diario"
}
